const postCloneChecklistBySite = {
  toastr: 'Checklist Clonada',
  toastr1: 'El Modelo fue actualizado con éxito'
};

export default postCloneChecklistBySite;
